import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { CheckForUpdateService } from "./shared/check-for-update.service";
import { PromptUpdateService } from "./shared/prompt-update.service";
import { MsalService } from "@azure/msal-angular";

declare let gtag: Function;
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "keen-and-wise";
  isIframe = false;

  constructor(
    private router: Router,
    checkForUpdates: CheckForUpdateService,
    promptUpdates: PromptUpdateService,
    private authService: MsalService
  ) {}
  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;
    if (window.location.href.includes("onetool-frontend-partners")) {
      this.addGAScript();
      this.setUpAnalytics();
    }
    this.authService.initialize();
  }

  addGAScript() {
    let gtagScript: HTMLScriptElement = document.createElement("script");
    gtagScript.async = true;
    gtagScript.src =
      "https://www.googletagmanager.com/gtag/js?id=" + "G-F1ZGCK5QSN";
    document.head.prepend(gtagScript);
    /** Disable automatic page view hit to fix duplicate page view count  **/
    gtag("config", "G-F1ZGCK5QSN", { send_page_view: false });
  }

  setUpAnalytics() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        gtag("config", "G-F1ZGCK5QSN", {
          page_path: event.urlAfterRedirects,
        });
      });
  }
}
